import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const SouthAsianMarkets = ({ data, StyleVar = 'box-card-style-default' }) => {
    return (
        <div className={`rn-card ${StyleVar}`}>
            <div className="inner">
                <div className="thumbnail">
                    <Link to={`/search?option=products&s=&country=${data.name.toLowerCase()}`}>
                        <figure className="img">
                            <img
                                className="img-fluid"
                                style={{ height: '120px', width: '100%', objectFit: 'cover' }}
                                src={`${process.env.PUBLIC_URL}/${data.image}`}
                                alt={`${data.name} Market`}
                            />
                        </figure>
                    </Link>
                </div>

                <div className="content" style={{ marginRight: "0 !important" }}>
                    <ul className="main-page-products">
                        <li className="text-ellipsis text-capitalize" style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                            <img
                                src={`${process.env.PUBLIC_URL}/${data.flag}`}
                                alt={`${data.name} flag`}
                                style={{
                                    width: '20px',
                                    height: '15px',
                                    marginRight: '8px',
                                    borderRadius: '2px',
                                    verticalAlign: 'middle',
                                    display: 'inline-block'
                                }}
                            />
                            <Link className="title mt-0" to={`/search?option=products&s=&country=${data.name.toLowerCase()}`} style={{ fontWeight: '600', color: '#333' }}>
                                {data.name}
                            </Link>
                        </li>
                        <li className="text-ellipsis" style={{ fontSize: '12px', color: '#666', lineHeight: '1.3' }}>
                            {data.description.split('\n').map((line, index) => (
                                <div key={index}>{line}</div>
                            ))}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

SouthAsianMarkets.propTypes = {
    data: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
        flag: PropTypes.string.isRequired,
        description: PropTypes.string
    }).isRequired,
    StyleVar: PropTypes.string
};

export default SouthAsianMarkets;